import React from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import {
  CFW_DROPDOWN_COUNTRY,
  CFW_IS_MOBILE,
  CFW_REFRESHER,
  GETALLSTORES,
  Response_SelectedTranslation,
} from "@genericComponents/CFW.js";
import { Clone, GetProductAndLanguage } from "@genericComponents/Common.js";
import ErrorBoundary from "@genericComponents/ErrorBoundary.js";
import { InitializeIndexedDBWorker } from "@genericComponents/InitializeIndexedDBWorker.js";
import { MaintainTranslations } from "@genericComponents/PFW.js";
import {
  GetState,
  RehydrationState,
  RemoveState,
  SetState,
} from "@genericComponents/StoreToolkit.js";
import { User } from "@genericComponents/User.js";
import registerServiceWorker from "@src/serviceWorkerRegistration.js";
import App from "@src/App.js";
const GetSelectedCountry =
  await import("@asyncImports/GetSelectedCountry.js").then(
    (mod) => mod.GetSelectedCountry,
  );
const IsMobile = await import("@asyncImports/IsMobile.js").then(
  (mod) => mod.IsMobile,
);
const AddCssStyles = await import("@asyncImports/AddCssStyles.js").then(
  (mod) => mod.AddCssStyles,
);
const GUID = await import("@asyncImports/GUID.js").then((mod) => mod.GUID);
const CleanUrl = await import("@asyncImports/CleanUrl.js").then(
  (mod) => mod.CleanUrl,
);
const { languageCode, productCode } = GetProductAndLanguage(
  window.location.pathname,
);
if (window.children) {
  delete window.children;
}
if (window.selectedTranslation) {
  delete window.selectedTranslation;
}
if (window.pcb) {
  delete window.pcb;
}
if (window.ncb) {
  delete window.ncb;
}
if (window.customButtons) {
  delete window.customButtons;
}
if (window.recommendIndex) {
  delete window.recommendIndex;
}
if (window.uploadEvent) {
  delete window.uploadEvent;
}
if (window?.processing) {
  delete window.processing;
}
if (window?.tempList) {
  delete window.tempList;
}
registerServiceWorker(languageCode, productCode);
const currentUrl = CleanUrl(
  `https://urtechcity.com${window.location.pathname}${
    window.location.search ?? ""
  }`,
);
const contextMenu = (e) => {
  if (e.target.hasAttribute("translated")) {
    const param = Clone(MaintainTranslations);
    const translationTypeId = parseInt(e.target.getAttribute("translated"), 10);
    param.Filter.TranslationTypeId = translationTypeId;
    param.Filter.LanguageCode = languageCode;
    param.TranslationTypeId = translationTypeId;
    param.LanguageCode = languageCode;
    RemoveState(`${CFW_REFRESHER}-translation`);
    window.selectedTranslation = param;
    SetState(Response_SelectedTranslation, GUID());
  }
  e.preventDefault();
};
const windowWidth = () => {
  const isMobile = GetState(CFW_IS_MOBILE);
  if (isMobile !== IsMobile()) {
    SetState(CFW_IS_MOBILE, IsMobile());
  }
};
window.removeEventListener("resize", windowWidth, false);
window.addEventListener("resize", windowWidth);
if (User.IsTranslator()) {
  window.removeEventListener("contextmenu", contextMenu, false);
  window.addEventListener("contextmenu", contextMenu);
}
const policyErrorListener = (e) => {
  if (["style-src-attr", "style-src-elem"].includes(e.violatedDirective)) {
    e.currentTarget.document.documentElement
      .querySelectorAll("*[style]")
      .forEach((el) => {
        if (el.style.cssText) {
          const styleId = `${el.style.cssText.replace(/\W/g, "")}`;
          const classResults = `.${styleId}{${el.style.cssText}}`;
          AddCssStyles(styleId, classResults);
          el.classList.add(styleId);
        }
        el.removeAttribute("style");
      });
  } else {
    console.log("Security Policy Violation", e);
  }
};
window.removeEventListener(
  "securitypolicyviolation",
  policyErrorListener,
  false,
);
window.addEventListener("securitypolicyviolation", policyErrorListener);
const globalError = (e) => {
  console.log("generic Error", e);
};
window.removeEventListener("error", globalError, false);
window.addEventListener("error", globalError);
window["__react-beautiful-dnd-disable-dev-warnings"] =
  window.location.host.includes("urtechcity.com");
window.IndexedDBPostMessage = InitializeIndexedDBWorker();
window.IndexedDBPostMessage(
  GETALLSTORES,
  null,
  (results) => {
    try {
      if (results?.db && results.action === GETALLSTORES) {
        RehydrationState(results?.db);
        if (!GetState(CFW_DROPDOWN_COUNTRY)) {
          SetState(CFW_DROPDOWN_COUNTRY, GetSelectedCountry());
        }
        hydrateRoot(
          document,
          <React.StrictMode>
            <BrowserRouter future={{ v7_startTransition: true }}>
              <ErrorBoundary>
                <App
                  currentUrl={currentUrl}
                  initData={window.initScripts}
                  css={window.cssFiles}
                  roles={User.Roles()}
                  isDefaultMobile={IsMobile()}
                />
              </ErrorBoundary>
            </BrowserRouter>
          </React.StrictMode>,
          {
            onRecoverableError(error, errorInfo) {
              console.error("React recoverable error", error, errorInfo);
            },
          },
        );
        import("web-vitals").then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
          onCLS(console.log);
          onLCP(console.log);
          onINP(console.log);
          onFCP(console.log);
          onTTFB(console.log);
        });
      }
    } catch (error) {
      console.log("Rehydration State Error", error.Message);
    }
  },
  (error) => {
    console.log("Rehydration State Error:", error);
  },
);
